import { React, useEffect, useState } from 'libs/react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { getComponentValue } from 'libs/google';
import './TextInput.scss';
export function GoogleAutocompleteInput(props) {
    const { name, ident, value, required, disabled, placeholder } = props;
    const [inputValue, setInputValue] = useState(value || '');
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(e) {
        setInputValue(e.currentTarget.value);
        if (props.onChange) {
            props.onChange(e.currentTarget.value);
        }
    }
    useEffect(() => {
        if (value !== undefined) {
            setInputValue(value);
        }
    }, [value]);
    /**
     * @function onKeyDown
     * @since 1.0.0
     * @hidden
     */
    function onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
        if (props.onKeyDown) {
            props.onKeyDown(e.key);
        }
    }
    const { ref } = usePlacesWidget({
        apiKey: process.env.GOOGLE_API_KEY,
        onPlaceSelected({ address_components, name, geometry }) {
            if (address_components) {
                const civicNumber = getComponentValue(address_components, 'street_number');
                const street = getComponentValue(address_components, 'route');
                const apartment = (getComponentValue(address_components, 'subpremise').match(/[0-9]/g) ||
                    []).join('');
                const city = getComponentValue(address_components, 'locality');
                const province = getComponentValue(address_components, 'administrative_area_level_1', 'short');
                const countryCode = getComponentValue(address_components, 'country', 'short');
                let latitude = 0;
                let longitude = 0;
                if (geometry && geometry.location) {
                    latitude = geometry.location.lat();
                    longitude = geometry.location.lng();
                }
                props.onLocationSelected({
                    civicNumber,
                    road: street,
                    apartment,
                    city,
                    province,
                    postalcode: getComponentValue(address_components, 'postal_code'),
                    country: countryCode,
                    latitude,
                    longitude
                });
            }
        },
        options: {
            types: ['address'],
            componentRestrictions: {
                country: ['ca', 'us']
            },
            fields: ['address_components', 'name', 'geometry']
        }
    });
    return (React.createElement("input", { ref: ref, id: ident, name: name, value: inputValue, required: required, pattern: required ? '^(?!\\s*$).+' : undefined, disabled: disabled, placeholder: placeholder, onBlur: onBlur, onFocus: onFocus, onInput: onChange, onChange: onChange, onKeyDown: onKeyDown }));
}
